import { useEffect, useMemo } from 'react';

import {
    buildClaimInsightsFilterCategories,
    DEFAULT_CLAIM_TYPE_FILTERS,
    enrichClaimForGridFilters,
} from 'services/claimInsightsHelpers';
import { Grids, useGridState } from 'store/grids/gridsSlice';

export const useClaimsGridData = ({ data, initialSortProperties }) => {
    const {
        activeFilters,
        filterPaneWidth,
        sort,
        updateFilterPaneWidth,
        updateGridActiveFilters,
        updateGridSort,
    } = useGridState(Grids.CLAIMS, initialSortProperties);
    const gridData = useMemo(() => (data ?? []).map(enrichClaimForGridFilters), [data]);
    const filterCategories = useMemo(
        () => buildClaimInsightsFilterCategories(gridData),
        [gridData],
    );

    useEffect(() => {
        if (activeFilters == null) {
            updateGridActiveFilters({ claimType: DEFAULT_CLAIM_TYPE_FILTERS });
        }
    }, [activeFilters, updateGridActiveFilters]);

    return {
        activeFilters,
        filterCategories,
        filterPaneWidth,
        gridData,
        onFilter: updateGridActiveFilters,
        sort,
        updateFilterPaneWidth,
        updateGridSort,
    };
};
